import {
    ComposedChart,
    Line,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer,
    ReferenceLine,
} from "recharts";
import { generateMarketInsightsSignStackChartData } from "./MarketInsightsData";
import { MarketInsightsChartTooltip } from "./MarketInsightsChartTooltip";

const data = generateMarketInsightsSignStackChartData(100);

export function MarketInsightsSignStackChart() {
    const maxPv = Math.max(...data.map((item) => item.pv));
    const minCnt = Math.min(...data.map((item) => item.cnt));

    const yAxisDomain = [
        Math.floor(minCnt / 1000) * 1000, // Round down to nearest 1000
        Math.ceil(maxPv / 1000) * 1000, // Round up to nearest 1000
    ];

    // TODO lol this has to be te dumbest thing I've seen AI generate
    const formatXAxisTick = (value: string) => {
        const pointNum = parseInt(value.replace("Point ", ""));
        if (pointNum === 1) {
            return "Jun 16";
        } else if (pointNum === 25) {
            return "6a";
        } else if (pointNum === 50) {
            return "12p";
        } else if (pointNum === 75) {
            return "6p";
        } else if (pointNum === 100) {
            return "Jun 17";
        }
        return "";
    };

    const ticks = ["Point 1", "Point 25", "Point 50", "Point 75", "Point 100"];

    return (
        <div className="rounded-[4px] dark:bg-[#2D3748] bg-white w-full h-full flex flex-auto flex-col">
            <ResponsiveContainer width="100%" height={350}>
                <ComposedChart
                    data={data}
                    margin={{
                        top: 20,
                        right: 20,
                        bottom: 20,
                        left: 20,
                    }}
                    stackOffset="sign"
                    barGap={0}
                    barCategoryGap={0}
                >
                    <CartesianGrid
                        strokeDasharray="3 3"
                        stroke="currentColor"
                        className="text-gray-400 dark:text-gray-700"
                        vertical={true}
                        horizontal={true}
                    />
                    <XAxis
                        dataKey="name"
                        padding={{ left: 0, right: 0 }}
                        tickFormatter={formatXAxisTick}
                        ticks={ticks}
                        interval={0}
                        tickCount={5}
                        stroke="currentColor"
                        className="text-gray-600 dark:text-gray-400"
                    />
                    <YAxis
                        domain={yAxisDomain}
                        tickFormatter={(value) =>
                            `${Math.round(value / 1000) * 1000}kW`
                        }
                        tickCount={5}
                        allowDecimals={false}
                        axisLine={false}
                        tickLine={false}
                        stroke="currentColor"
                        className="text-gray-600 dark:text-gray-400"
                    />
                    <Tooltip content={<MarketInsightsChartTooltip unit="kW" />} />
                    <Legend 
                        verticalAlign="bottom"
                        height={36}
                        wrapperStyle={{
                        paddingTop: '20px',
                        fontSize: '14px'
                        }}
                        formatter={(value) => (
                        <span className="text-neutral-600 dark:text-[#CEE0EF]">{value}</span>
                        )}
                    />
                    <ReferenceLine y={0} stroke="#000" />
                    <Bar
                        dataKey="pv"
                        name="Discharging"
                        fill="#413ea0"
                        stackId="sign"
                    />
                    <Bar
                        dataKey="cnt"
                        name="Charging"
                        fill="#14d5e4"
                        stackId="sign"
                    />
                    <Line
                        type="monotone"
                        dataKey={(data) => data.pv + data.cnt}
                        name="Net Output"
                        stroke="#ff7300"
                        dot={false}
                    />
                </ComposedChart>
            </ResponsiveContainer>
        </div>
    );
}

export default MarketInsightsSignStackChart;
